// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rd3t-node {
  cursor: pointer;
  fill: none !important;
  stroke: none !important;
  stroke-width: 0 !important;
}

.rd3t-link {
  fill: none;
  stroke: rgb(63, 63, 242) !important;
}

.rd3t-leaf-node {
  stroke: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/custom_tree.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".rd3t-node {\n  cursor: pointer;\n  fill: none !important;\n  stroke: none !important;\n  stroke-width: 0 !important;\n}\n\n.rd3t-link {\n  fill: none;\n  stroke: rgb(63, 63, 242) !important;\n}\n\n.rd3t-leaf-node {\n  stroke: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
